import { Checkbox } from "../../../../lib/ui/controls/Checkbox";
import { C } from "../../../../lib/ui/constructors";
import { ewent } from "../../../../lib/reactive";
import { util } from "../../../../lib/util/util";
import TextField from "../../../../lib/ui/controls/TextField";
import { DropdownSelection } from "../../widgets/DropdownSelection";
import { direction } from "../../../../lib/runescape/movement";
import { CursorType } from "../../../../lib/runescape/CursorType";
import NumberInput from "../../../../lib/ui/controls/NumberInput";
import { TileCoordinates } from "../../../../lib/runescape/coordinates";
import { TileArea } from "../../../../lib/runescape/coordinates/TileArea";
import LightButton from "../../widgets/LightButton";
import { DrawTileAreaInteraction } from "../DrawTileAreaInteraction";
import { ValueInteraction } from "../../../../lib/gamemap/interaction/ValueInteraction";
import InteractionTopControl from "../../map/InteractionTopControl";
import { DrawOffset } from "../../shortcut_editing/interactions/DrawOffset";
import { Transportation } from "../../../../lib/runescape/transportation";
import { TileTransform } from "../../../../lib/runescape/coordinates/TileTransform";
import NumberSlider from "../../../../lib/ui/controls/NumberSlider";
import ButtonRow from "../../../../lib/ui/ButtonRow";
import { NislIcon } from "../../nisl";
export class ParsingParameter {
    constructor(_default_value) {
        this._default_value = _default_value;
    }
    default(f) {
        this._default_value = f;
        return this;
    }
    getDefault(loc) {
        return ParsingParameter.P.apply(this._default_value, loc);
    }
}
(function (ParsingParameter) {
    var copyUpdate2 = util.copyUpdate2;
    var hboxl = C.hboxl;
    var inlineimg = C.inlineimg;
    var spacer = C.spacer;
    var span = C.span;
    let P;
    (function (P) {
        function apply(p, loc) {
            if (typeof p == "function")
                return p(loc);
            else
                return p;
        }
        P.apply = apply;
    })(P = ParsingParameter.P || (ParsingParameter.P = {}));
    function bool() {
        return new class extends ParsingParameter {
            constructor() {
                super(() => false);
            }
            renderForm(depth) {
                const self = this;
                return new class extends ParsingParameter.Editor {
                    constructor() {
                        super(self);
                    }
                    render_implementation(value) {
                        this.control.append(new Checkbox()
                            .onCommit(v => this.commit(v))
                            .setValue(value));
                    }
                };
            }
        };
    }
    ParsingParameter.bool = bool;
    function int(bounds = [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER]) {
        return new class extends ParsingParameter {
            constructor() {
                super((loc) => Math.max(P.apply(bounds, loc)[0], 0));
            }
            renderForm(depth, loc) {
                const self = this;
                return new class extends ParsingParameter.Editor {
                    constructor() {
                        super(self);
                    }
                    render_implementation(value) {
                        const [min, max] = P.apply(bounds, loc);
                        if (max - min > 20) {
                            this.control.append(new NumberInput(min, max)
                                .onCommit(v => this.commit(v))
                                .setValue(value));
                        }
                        else {
                            this.control.append(new NumberSlider(min, max)
                                .onCommit(v => this.commit(v))
                                .setValue(value));
                        }
                    }
                };
            }
        };
    }
    ParsingParameter.int = int;
    function floor() {
        return int([0, 3]);
    }
    ParsingParameter.floor = floor;
    function time() {
        return int([0, 20]).default(3);
    }
    ParsingParameter.time = time;
    function string() {
        return new class extends ParsingParameter {
            constructor() {
                super(() => "");
            }
            renderForm(depth) {
                const self = this;
                return new class extends ParsingParameter.Editor {
                    constructor() {
                        super(self);
                    }
                    render_implementation(value) {
                        this.control.append(new TextField()
                            .onCommit(v => this.commit(v))
                            .setValue(value));
                    }
                };
            }
        };
    }
    ParsingParameter.string = string;
    function choose(type_class, choices) {
        return new class extends ParsingParameter {
            constructor() {
                super((loc) => P.apply(choices, loc)[0]);
            }
            renderForm(depth, loc) {
                const self = this;
                return new class extends ParsingParameter.Editor {
                    render_implementation(value) {
                        this.control.append(new DropdownSelection({ type_class: P.apply(type_class, loc) }, P.apply(choices, loc))
                            .onSelection(v => this.commit(v))
                            .setValue(value));
                    }
                }(self);
            }
        };
    }
    ParsingParameter.choose = choose;
    function tileArea2(allow_relative = true, allow_absolute = true) {
        return (new class extends ParsingParameter {
            constructor() {
                super(null);
            }
            renderForm(depth, loc, map) {
                const self = this;
                const transform = loc.getTransform();
                const inverse_transform = loc.getInverseTransform();
                return new class extends ParsingParameter.Editor {
                    constructor() {
                        super(...arguments);
                        this.wip_value = null;
                        this.interaction = null;
                    }
                    render_implementation(value) {
                        this.wip_value = value ? {
                            type: value.type,
                            tiles: TileArea.activate(value.area).getTiles()
                        } : null;
                        this.update_render();
                    }
                    act(type) {
                        const editor = this;
                        map.setInteraction(this.interaction = (new class extends ValueInteraction {
                            constructor() {
                                super();
                                let current_tiles = editor.wip_value?.tiles || [];
                                if (editor.wip_value?.type == "relativetoloc") {
                                    current_tiles = current_tiles.map(t => TileCoordinates.transform(t, transform));
                                }
                                const interact = new DrawTileAreaInteraction(current_tiles)
                                    .onPreview(v => this.preview(v))
                                    .attachTopControl(null)
                                    .addTo(this);
                                this.attachTopControl(new InteractionTopControl({ name: "Draw Tile Area" })
                                    .setContent(c("<div style='font-family: monospace; white-space:pre'></div>")
                                    .append(c().text(`[Shift + Mouse] add tiles, [Alt + Mouse] remove tiles`))));
                                interact.preview(current_tiles);
                            }
                        })
                            .onPreview(v => {
                            if (v.length > 0) {
                                let new_tiles = v;
                                if (type == "relativetoloc") {
                                    new_tiles = new_tiles.map(t => TileCoordinates.transform(t, inverse_transform));
                                }
                                this.wip_value = {
                                    type: type,
                                    tiles: new_tiles
                                };
                            }
                            else {
                                this.wip_value = null;
                            }
                            this.update_render();
                        })
                            .onEnd(() => {
                            this.commitTiles();
                            this.interaction = null;
                            this.update_render();
                        }));
                    }
                    commitTiles() {
                        if (this.wip_value) {
                            this.commit({
                                type: this.wip_value.type,
                                area: TileArea.fromTiles(this.wip_value.tiles)
                            });
                        }
                        else {
                            this.commit(null);
                        }
                    }
                    update_render() {
                        this.control.empty().append(hboxl(this.wip_value
                            ? span(`${this.wip_value.tiles.length} tiles [${this.wip_value.type == "relativetoloc" ? "rel" : "abs"}]`)
                            : span("None"), spacer(), this.interaction ?
                            new ButtonRow()
                                .buttons(new LightButton("Abort")
                                .onClick(() => {
                                this.interaction?.cancel();
                                this.update_render();
                            }), new LightButton("")
                                .append(NislIcon.delete())
                                .onClick(() => {
                                this.wip_value = null;
                                this.interaction?.cancel();
                                this.update_render();
                                this.commitTiles();
                            }))
                            : new ButtonRow()
                                .buttons(allow_relative ? new LightButton("Rel")
                                .onClick(() => this.act("relativetoloc")) : undefined, allow_absolute ? new LightButton("Abs")
                                .onClick(() => this.act("absolute")) : undefined, new LightButton("")
                                .append(NislIcon.delete())
                                .onClick(() => {
                                this.wip_value = null;
                                this.interaction?.cancel();
                                this.update_render();
                                this.commitTiles();
                            }))));
                    }
                }(self);
            }
        });
    }
    ParsingParameter.tileArea2 = tileArea2;
    (function (tileArea2) {
        function translate(instance, area) {
            if (!area)
                return null;
            switch (area.type) {
                case "absolute":
                    return area.area;
                case "relativetoloc":
                    return TileArea.transform(area.area, instance.getTransform());
            }
        }
        tileArea2.translate = translate;
    })(tileArea2 = ParsingParameter.tileArea2 || (ParsingParameter.tileArea2 = {}));
    function movement() {
        return (new class extends ParsingParameter {
            constructor() {
                super(null);
            }
            renderForm(depth, loc, map) {
                const self = this;
                const transform = loc.getTransform();
                const inverse_transform = loc.getInverseTransform();
                return new class extends ParsingParameter.Editor {
                    constructor() {
                        super(...arguments);
                        this.interaction = null;
                        this.wip_value = null;
                    }
                    render_implementation(value) {
                        this.wip_value = value?.fixed_target ? {
                            relative: value.fixed_target.relative,
                            origin_only: value.fixed_target.origin_only,
                            tiles: TileArea.activate(value.fixed_target.target).getTiles()
                        } : null;
                        this.update_render();
                    }
                    startAction(type) {
                        const editor = this;
                        if (type == "offset") {
                            map.setInteraction(new DrawOffset({})
                                .onCommit(v => {
                                this.wip_value = null;
                                this.commit({
                                    offset: Transportation.EntityActionMovement.Offset.transform(v.offset, inverse_transform.matrix)
                                });
                                this.render();
                            }));
                        }
                        else {
                            const will_be_relative = type == "relativefixed" || type == "originonly";
                            map.setInteraction(this.interaction = (new class extends ValueInteraction {
                                constructor() {
                                    super();
                                    let current_tiles = editor.wip_value?.tiles || [];
                                    if (editor.wip_value?.relative) {
                                        current_tiles = current_tiles.map(t => TileCoordinates.transform(t, transform));
                                    }
                                    const interact = new DrawTileAreaInteraction(current_tiles)
                                        .onPreview(v => this.preview(v))
                                        .attachTopControl(null)
                                        .addTo(this);
                                    this.attachTopControl(new InteractionTopControl({ name: "Draw Tile Area" })
                                        .setContent(c("<div style='font-family: monospace; white-space:pre'></div>")
                                        .append(c().text(`[Shift + Mouse] add tiles, [Alt + Mouse] remove tiles`))));
                                    interact.preview(current_tiles);
                                }
                            })
                                .onPreview(v => {
                                if (v.length > 0) {
                                    let new_tiles = v;
                                    if (will_be_relative) {
                                        new_tiles = new_tiles.map(t => TileCoordinates.transform(t, inverse_transform));
                                    }
                                    this.wip_value = {
                                        relative: will_be_relative,
                                        tiles: new_tiles,
                                        origin_only: type == "originonly"
                                    };
                                }
                                else {
                                    this.wip_value = null;
                                }
                                this.update_render();
                            })
                                .onEnd(() => {
                                this.commitWIP();
                                this.interaction = null;
                                this.update_render();
                            }));
                        }
                    }
                    commitWIP() {
                        if (this.wip_value) {
                            this.commit({
                                fixed_target: {
                                    target: TileArea.fromTiles(this.wip_value.tiles),
                                    relative: this.wip_value.relative,
                                    origin_only: this.wip_value.origin_only
                                },
                            });
                        }
                        else {
                            this.commit({ offset: { x: 0, y: 0, level: 0 } });
                        }
                    }
                    update_render() {
                        const offset = this.get()?.offset ?? { x: 0, y: 0, level: 0 };
                        this.control.empty().append(hboxl(this.wip_value
                            ? span(`${this.wip_value.tiles.length} tiles [${(this.wip_value.relative ? "rel" : "abs") + (this.wip_value.origin_only ? ", org" : "")}]`)
                            : span(`+ (${offset.x} | ${offset.y} | ${offset.level})`), spacer(), this.interaction ?
                            new ButtonRow()
                                .buttons(new LightButton("Abort")
                                .onClick(() => {
                                this.interaction?.cancel();
                                this.update_render();
                            }), new LightButton("")
                                .append(NislIcon.delete())
                                .onClick(() => {
                                this.wip_value = null;
                                this.interaction?.cancel();
                                this.update_render();
                                this.commitWIP();
                            }))
                            : new ButtonRow()
                                .buttons(new LightButton("Off")
                                .onClick(() => this.startAction("offset")), new LightButton("Rel")
                                .onClick(() => this.startAction("relativefixed")), new LightButton("Abs")
                                .onClick(() => this.startAction("absolutefixed")), new LightButton("Ori")
                                .onClick(() => this.startAction("originonly")), new LightButton("")
                                .append(NislIcon.delete())
                                .onClick(() => {
                                this.wip_value = null;
                                this.interaction?.cancel();
                                this.update_render();
                                this.commitWIP();
                            }))));
                    }
                }(self);
            }
        });
    }
    ParsingParameter.movement = movement;
    function dir() {
        return choose({
            toHTML: (v) => c().text(direction.toString(v))
        }, () => direction.all);
    }
    ParsingParameter.dir = dir;
    function tileArea(relative_to_loc = true) {
        return (new class extends ParsingParameter {
            constructor() {
                super(TileArea.init({ x: 0, y: 0, level: 0 }));
            }
            renderForm(depth, loc, map) {
                const self = this;
                const transform = relative_to_loc ? loc.getTransform() : TileTransform.identity();
                const inverse_transform = relative_to_loc ? loc.getInverseTransform() : TileTransform.identity();
                return new class extends ParsingParameter.Editor {
                    constructor() {
                        super(...arguments);
                        this.interaction = null;
                    }
                    render_implementation(value) {
                        this.edited_tiles = TileArea.activate(value).getTiles().filter(t => t.x != 0 || t.y != 0);
                        this.update_render();
                    }
                    activate() {
                        const editor = this;
                        if (this.interaction) {
                            this.interaction.cancel();
                        }
                        else {
                            map.setInteraction(this.interaction = (new class extends ValueInteraction {
                                constructor() {
                                    super();
                                    new DrawTileAreaInteraction(editor.edited_tiles.map(t => TileCoordinates.transform(t, transform)))
                                        .onPreview(v => this.preview(v))
                                        .attachTopControl(null)
                                        .addTo(this);
                                    this.attachTopControl(new InteractionTopControl({ name: "Draw Tile Area" })
                                        .setContent(c("<div style='font-family: monospace; white-space:pre'></div>")
                                        .append(c().text(`[Shift + Mouse] add tiles, [Alt + Mouse] remove tiles`))));
                                }
                            })
                                .onPreview(v => {
                                this.edited_tiles = v.map(t => TileCoordinates.transform(t, inverse_transform));
                                this.update_render();
                            })
                                .onEnd(() => {
                                this.commitTiles();
                                this.interaction = null;
                                this.update_render();
                            }));
                            this.update_render();
                        }
                    }
                    commitTiles() {
                        this.commit(TileArea.fromTiles(this.edited_tiles));
                    }
                    update_render() {
                        this.control.empty().append(hboxl(this.edited_tiles.length > 0
                            ? c().text(`${this.edited_tiles.length} tiles near ${TileCoordinates.toString(this.edited_tiles[0])}`)
                            : c().text(`${this.edited_tiles.length} tiles`), new LightButton(this.interaction ? "Stop Editing" : "Edit")
                            .onClick(() => {
                            this.activate();
                        }), new LightButton("Reset")
                            .onClick(() => {
                            this.edited_tiles = [];
                            this.interaction?.cancel();
                            this.update_render();
                            this.commitTiles();
                        })));
                    }
                }(self);
            }
        });
    }
    ParsingParameter.tileArea = tileArea;
    function rec(elements) {
        return new ParsingParameter.Rec(elements);
    }
    ParsingParameter.rec = rec;
    function element(name, type, optional = false) {
        return {
            name: name,
            type: type,
            optional: optional,
        };
    }
    ParsingParameter.element = element;
    function cursorType() {
        return choose(() => ({
            toHTML: (v) => {
                let meta = CursorType.meta(v);
                return c(`<div><img style="height: 18px; object-fit: contain; margin-right: 3px" src="${meta.icon_url}" alt="${meta.description}">${meta.description}</div>`);
            }
        }), CursorType.all().map(i => i.type));
    }
    ParsingParameter.cursorType = cursorType;
    function customAction() {
        return rec({
            name: element("Name", string()),
            cursor: element("Icon", cursorType())
        });
    }
    ParsingParameter.customAction = customAction;
    function locAction() {
        return choose((loc) => ({
            toHTML: (v) => {
                const a = loc.prototype.actions[v.id];
                if (!a)
                    return c().text("undefined");
                return hboxl(inlineimg(CursorType.meta(a[1]).icon_url), " ", a[0]);
            }
        }), (loc) => loc.prototype.actions.map((a, i) => ({ id: i })));
    }
    ParsingParameter.locAction = locAction;
    function action() {
        return either({
            loc: locAction(),
            custom: customAction(),
        }).default(() => ({
            loc: {
                id: 0
            }
        }));
    }
    ParsingParameter.action = action;
    class Editor {
        constructor(type) {
            this.type = type;
            this.control = c();
            this.additional = c();
            this.value_changed = ewent();
        }
        activate() {
        }
        render() {
            this.control.empty();
            this.additional.empty();
            this.render_implementation(this.value);
        }
        commit(v) {
            this.value = v;
            this.value_changed.trigger(v);
        }
        get() {
            return this.value;
        }
        set(value) {
            this.value = value;
            this.render();
            return this;
        }
        onChange(f) {
            this.value_changed.on(f);
            return this;
        }
    }
    ParsingParameter.Editor = Editor;
    class Rec extends ParsingParameter {
        constructor(elements) {
            super((loc) => {
                return Object.fromEntries(Object.entries(elements).map(([key, value]) => [key, value.optional ? undefined : value.type.getDefault(loc)])); // There's probably an idiomatic way to get this to typecheck without this cast
            });
            this.elements = elements;
        }
        renderForm(depth, loc, map) {
            const self = this;
            return new class extends ParsingParameter.Editor {
                constructor() {
                    super(self);
                }
                render_implementation(value) {
                    this.elements = Object.entries(self.elements).map(([id, element]) => new Rec.ElementWidget(element, element.optional ? "check" : "none", depth + 1, loc, map)
                        .set(value?.[id])
                        .onChange(v => {
                        this.commit(copyUpdate2(this.get(), e => e[id] = v));
                    }));
                    this.additional.append(...this.elements.map(e => e.additional));
                }
            };
        }
    }
    ParsingParameter.Rec = Rec;
    (function (Rec) {
        var hbox = C.hbox;
        class ElementWidget extends Editor {
            constructor(element, cb_type, depth, loc, map) {
                super(element.type);
                this.element = element;
                this.cb_type = cb_type;
                this.depth = depth;
                this.loc = loc;
                this.map = map;
                this.sub = null;
                this.additional
                    .css("margin-left", "3px")
                    .css("padding-left", "3px")
                    .css("border-left", `2px solid ${["blue", "purple", "green"][this.depth % 3]}`)
                    .css("margin-top", "4px")
                    .css("margin-bottom", "4px");
            }
            render_implementation(value) {
                const name_column = c().css("min-width", "100px");
                const control_column = c().css("flex-grow", "1");
                const el_content = c();
                switch (this.cb_type) {
                    case "check":
                        this.checkbox = new Checkbox(this.element.name, "checkbox");
                        break;
                    case "radio":
                        this.checkbox = new Checkbox(this.element.name, "radio");
                        break;
                }
                if (this.checkbox) {
                    this.checkbox
                        .setValue(value !== undefined)
                        .onCommit((v) => {
                        if (v != (this.get() !== undefined)) {
                            const value = v ? this.element.type.getDefault(this.loc) : undefined;
                            this.commit(value);
                            this.render();
                            if (v)
                                this.sub.activate();
                        }
                    })
                        .appendTo(name_column);
                }
                else {
                    name_column.text(this.element.name);
                }
                this.additional.append(hbox(name_column, control_column), el_content);
                this.sub = null;
                if (value !== undefined) {
                    this.sub = this.element.type
                        .renderForm(this.depth + 1, this.loc, this.map)
                        .set(value)
                        .onChange(v => this.commit(v));
                    control_column.append(this.sub.control);
                    el_content.append(this.sub.additional);
                }
            }
        }
        Rec.ElementWidget = ElementWidget;
    })(Rec = ParsingParameter.Rec || (ParsingParameter.Rec = {}));
    function list(base, defaultSize = 0) {
        return new class extends ParsingParameter {
            constructor() { super(l => new Array(defaultSize).fill(null).map(() => base.getDefault(l))); }
            renderForm(depth, loc, map) {
                const self = this;
                return new class extends ParsingParameter.Editor {
                    constructor() {
                        super(self);
                    }
                    render_implementation(value) {
                        this.control.append(new LightButton("Add")
                            .onClick(() => {
                            this.commit(copyUpdate2(this.get(), e => e.push(base.getDefault(loc))));
                            this.render();
                        }));
                        this.elements = value.map((element, i) => new Rec.ElementWidget({
                            name: `Item ${i}`,
                            type: base
                        }, "check", depth + 1, loc, map)
                            .set(element)
                            .onChange(v => {
                            if (v == undefined) {
                                this.commit(copyUpdate2(this.get(), e => e.splice(i, 1)));
                                this.render();
                            }
                            else {
                                this.commit(copyUpdate2(this.get(), e => e[i] = v));
                            }
                        }));
                        this.additional.append(...this.elements.map(e => e.additional));
                    }
                };
            }
        };
    }
    ParsingParameter.list = list;
    function either(elements) {
        return new class extends ParsingParameter {
            constructor() {
                super((loc) => {
                    const [key, value] = Object.entries(elements)[0];
                    return Object.fromEntries([[key, value.getDefault(loc)]]);
                });
            }
            renderForm(depth, loc, map) {
                const self = this;
                return new class extends ParsingParameter.Editor {
                    constructor() {
                        super(self);
                    }
                    render_implementation(value) {
                        this.elements = Object.entries(elements).map(([id, element], index) => new Rec.ElementWidget({
                            type: element,
                            name: id
                        }, "radio", depth + 1, loc, map)
                            .set(value?.[id])
                            .onChange(v => {
                            if (v !== undefined) {
                                this.elements.forEach((e, i) => {
                                    if (i != index)
                                        e.set(undefined);
                                });
                            }
                            this.commit({ [id]: v });
                        }));
                        this.additional.append(...this.elements.map(e => e.additional));
                    }
                };
            }
        };
    }
    ParsingParameter.either = either;
    function offset(relative_to_loc = true) {
        return new class extends ParsingParameter {
            renderForm(depth, loc, map) {
                const transform = loc.getTransform();
                const inverse_transform = loc.getInverseTransform();
                return new class extends ParsingParameter.Editor {
                    render_implementation(value) {
                        this.transformed_value = relative_to_loc
                            ? Transportation.EntityActionMovement.Offset.transform(value, transform.matrix)
                            : value;
                        this.control.append(hboxl(new NumberInput(-6400, 6400).setValue(this.transformed_value.x)
                            .onCommit(v => this.save(copyUpdate2(this.transformed_value, e => e.x = v))), " | ", new NumberInput(-6400, 6400).setValue(this.transformed_value.y)
                            .onCommit(v => this.save(copyUpdate2(this.transformed_value, e => e.y = v))), " | ", new NumberInput(-3, 3).setValue(this.transformed_value.level)
                            .onCommit(v => this.save(copyUpdate2(this.transformed_value, e => e.level = v))), new LightButton("Draw").onClick(() => {
                            map.setInteraction(new DrawOffset({})
                                .onCommit(v => {
                                this.save(v.offset);
                                this.render();
                            }));
                        })));
                    }
                    save(offset) {
                        this.transformed_value = offset;
                        const saved_value = relative_to_loc
                            ? Transportation.EntityActionMovement.Offset.transform(offset, inverse_transform.matrix)
                            : offset;
                        this.commit(saved_value);
                    }
                }(this);
            }
        }({ x: 0, y: 0, level: 0 });
    }
    ParsingParameter.offset = offset;
})(ParsingParameter || (ParsingParameter = {}));
